var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTimePlayed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "time_played",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M21,9c-0.256,0-0.512-0.098-0.707-0.293l-3-3c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0 l3,3c0.391,0.391,0.391,1.023,0,1.414C21.512,8.902,21.256,9,21,9z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,5.059V4h2.5C15.329,4,16,3.329,16,2.5S15.329,1,14.5,1h-7C6.671,1,6,1.671,6,2.5S6.671,4,7.5,4H10v1.059 C5.501,5.557,2,9.368,2,14c0,4.971,4.029,9,9,9s9-4.029,9-9C20,9.368,16.499,5.557,12,5.059z M15.938,18.938L11,14V7 c3.866,0,7,3.134,7,7C18,15.933,17.205,17.672,15.938,18.938z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimePlayed);
export default __webpack_public_path__ + "static/media/ic_time_played.efa8a1adfe004a730e3a6a3f4742df23.svg";
export { ForwardRef as ReactComponent };